import axios from '@/bootstrap/axios';

/*
 * Every method below takes an optional trailing `config`, merged into the Axios
 * request config. It exists so a caller can set per-request flags the response
 * interceptor reads — today that is `handlesForbidden: true`, which tells the
 * interceptor not to navigate to the forbidden page because the calling screen
 * renders its own denied state. Omitting it leaves every existing call byte-for-
 * byte as it was.
 */
export default {
    get(url, filter, config) {
        const request = {
            params: filter,
            ...config,
        };
        //
        // const CancelToken = axios.CancelToken
        // const source = CancelToken.source()
        //
        //
        // params.cancelToken = source.token;

        return axios.get(url, request);

        // return source
    },
    getFile(url, filter) {
        const request = {
            params: filter,
            responseType: 'arraybuffer',
        };
        //
        // const CancelToken = axios.CancelToken
        // const source = CancelToken.source()
        //
        //
        // params.cancelToken = source.token;

        return axios.get(url, request);

        // return source
    },

    fetch(url, config) {
        return axios.get(url, config);
    },

    post(url, request, config) {
        // const CancelToken = axios.CancelToken;
        // const source = CancelToken.source();
        //
        // params.cancelToken = source.token;
        //
        request = request || {};

        request.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };

        return axios.post(url, request, config);

        // return source;
    },

    put(url, request, config) {
        // const CancelToken = axios.CancelToken;
        // const source = CancelToken.source();
        //
        // params.cancelToken = source.token;
        //

        request = request || {};

        request.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };

        return axios.put(url, request, config);

        // return source;
    },
    patch(url, params) {
        // const CancelToken = axios.CancelToken;
        // const source = CancelToken.source();
        //
        // params.cancelToken = source.token;

        const request = {
            data: params,
        };

        return axios.patch(url, request);

        // return source;
    },
    delete(url, filter, config) {
        // const CancelToken = axios.CancelToken;
        // const source = CancelToken.source();
        //
        // params.cancelToken = source.token;

        const request = {
            params: filter,
            ...config,
        };

        return axios.delete(url, request);

        // return source;
    },
    batch(calls) {
        return Promise.all(calls); // updated to use promise.all because axios.all is deprecated
    },
};
